import React from 'react';
import glamorous from 'glamorous';
import { MENU_ENTRIES } from './constants';


const OverviewOfRecallDataUploadingProcess = ({ onSectionChange }) => {
  return (
    <div>
      <h3>
        OVERVIEW OF RECALL DATA UPLOADING PROCESS
      </h3>
      <div>
        <p>
          To upload recalls on the OECD <i>GlobalRecalls</i> portal, the following six steps should be implemented:
        </p>
        <glamorous.Ul
          className="pt-list"
          css={{
            '& > li': {
              marginBottom: 10,
            }
          }}
        >
          <li>
            <strong>Step 1:</strong> Create an XML file describing the recall to be created/modified/deleted (see
            section: <a
            onClick={e => onSectionChange(MENU_ENTRIES.creatingRecallInXmlFormat)}>Creating a recall
            in
            XML format</a>).
          </li>
          <li>
            <strong>Step 2:</strong> Validate the XML file (see section: <a
            onClick={e => onSectionChange(MENU_ENTRIES.xmlValidation)}>Validating
            your XML file</a>).
          </li>
          <li>
            <strong>Step 3:</strong> Copy the XML file into a folder (this will be the folder that the user/server will
            compress into a zip
            file).
          </li>
          <li>
            <strong>Step 4:</strong> Copy the picture attachment(s), if any, and add them into the same folder (see
            section: <a
            onClick={e => onSectionChange(MENU_ENTRIES.ensureXmlAndImagesInOneFolder)}>Ensuring all XML
            and image files are in one folder</a>).
          </li>
          <li>
            <strong>Step 5:</strong> Compress the folder to a ZIP file (see section: <a
            onClick={e => onSectionChange(MENU_ENTRIES.creatingZipFile)}>Creating a ZIP file</a>).
          </li>
          <li>
            <strong>Step 6:</strong> Upload the ZIP file using the Administration page or the API (see section: <a
            onClick={e => onSectionChange(MENU_ENTRIES.uploadingZipToPortal)}>Uploading the zip file to the
            portal</a>).
          </li>
        </glamorous.Ul>
      </div>
      <br/>
      <h4>
        For automated uploads <i>via</i> the API
      </h4>
      <div>
        The steps above and the XML format requirements are the same whether you are manually or automatically uploading
        your recalls to the <i>GlobalRecalls</i> portal. The only difference is that if the recalls are uploaded
        manually, the above steps will be undertaken by a user, but if an agency has automated its recall upload
        process <i>via</i> the
        API,
        the above steps will be undertaken automatically by a server.
      </div>
      <br/>
      <p>
        For more information, see section: <a onClick={e => onSectionChange(MENU_ENTRIES.apiTechnicalDetails)}>API
        technical details for automated uploads</a>.
      </p>
    </div>
  );
};

export default OverviewOfRecallDataUploadingProcess;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/process-description.js